import type { UploadedFileType } from '../../../contexts';
import type { CustomFile } from '../../types';

const TARGET_FILE_KEYS = ['size', 'lastModified'] as const;

export function isDuplicateFile(
  file: UploadedFileType,
  fileList: CustomFile[]
): boolean {
  return fileList.some(({ data }) => {
    const isFileNameExist =
      file.name === data.name || file.name == data.originName;

    return (
      isFileNameExist &&
      fileList.some(({ data }) =>
        TARGET_FILE_KEYS.every((key) => data[key] === file[key])
      )
    );
  });
}
